import React from 'react';
import { format } from 'date-fns';
import { UsageStats } from '../../types';
import { bots } from '../../data/bots';

interface UsageTableProps {
  data: UsageStats[];
}

const UsageTable: React.FC<UsageTableProps> = ({ data }) => {
  // Get bot details from bots data
  const getBotDetails = (botId: string) => {
    const bot = bots.find(b => b.id === botId) || 
                bots.flatMap(b => b.subBots || []).find(sb => sb.id === botId);
    return {
      title: bot?.title || 'Unknown Bot',
      price: bot?.price || 0
    };
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Bot
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Credits Used
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((usage) => {
            const botDetails = getBotDetails(usage.botId);
            return (
              <tr key={usage.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {format(new Date(usage.timestamp), 'yyyy-MM-dd HH:mm:ss')}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {botDetails.title}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  ${botDetails.price.toFixed(2)}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50">
            <td colSpan={2} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              Total
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              ${data.reduce((sum, item) => sum + getBotDetails(item.botId).price, 0).toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default UsageTable;